import SnapshotDashboard from './SnapshotDashboard';

export default SnapshotDashboard;
